import { useMemo } from 'react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
var selector = function selector(states) {
  var _states$mediaState;
  return {
    mediaProvider: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider
  };
};
export var useMediaProvider = function useMediaProvider(pluginInjectionApi) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(pluginInjectionApi, ['media'], selector),
    mediaProvider = _useSharedPluginState.mediaProvider;
  var provider = useMemo(function () {
    return mediaProvider;
  }, [mediaProvider]);
  return provider;
};